import { GetReportsQueryAction } from './GetReportsQueryAction';
import { GetReportsQuerySuccessAction } from './GetReportsQuerySuccessAction';
import { GetSsrsConfigAction } from './GetSsrsConfigAction';
import { GetSsrsConfigSuccessAction } from './GetSsrsConfigSuccessAction';

export type Actions = GetReportsQueryAction |
                      GetReportsQuerySuccessAction |
                      GetSsrsConfigAction |
                      GetSsrsConfigSuccessAction;

export * from './GetReportsQueryAction';
export * from './GetReportsQuerySuccessAction';
export * from './GetSsrsConfigAction';
export * from './GetSsrsConfigSuccessAction';



// WEBPACK FOOTER //
// ./src/app/report/store/actions/index.ts